
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { formatDateTime } from "@/utils/admin-utils";

interface UsersTabProps {
  users: any[];
}

export const UsersTab = ({ users }: UsersTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Users</CardTitle>
        <CardDescription>All registered users</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {users.map((user) => (
            <Card key={user.id} className="p-4">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold text-lg">
                    {user.first_name} {user.last_name}
                  </h3>
                  <div className="space-y-2 mt-2">
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Phone:</span> {user.phone || 'No phone number'}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Role:</span> {user.user_roles?.[0]?.role || 'User'}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">User ID:</span> {user.id}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">Joined:</span> {formatDateTime(user.created_at)}
                    </p>
                  </div>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs ${
                  user.user_roles?.[0]?.role === 'admin' 
                    ? 'bg-purple-100 text-purple-800' 
                    : 'bg-blue-100 text-blue-800'
                }`}>
                  {user.user_roles?.[0]?.role || 'user'}
                </span>
              </div>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
